/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useRef, useState } from "react";

import cn from "classnames";
import { useOnClickOutside } from "usehooks-ts";

import { Input } from "../Input";
import { Spinner } from "../Loaders";
import Stack from "../Stack/Stack";

import { FilteredMenu } from "./FilteredMenu";

import { NewDropDown } from ".";

const SearchableDropDown = ({
  data,
  children,
  isFetchingMore,
  topSlot,
  bottomSlot,
  anchorSlot,
  anchorClassName,
  menuClassName,
  anchorArgs,
  menuArgs,
  inputArgs,
  hideTopSlotOnSearch,
  onSearchChange,
  className,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);

    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const SearchInput = (
    <Input
      value={search}
      onChange={handleSearch}
      onClick={(e) => {
        e.stopPropagation();
        setOpen(true);
        if (inputArgs && inputArgs.onClick) inputArgs.onClick(e);
      }}
      placeholder="Search..."
      {...inputArgs}
      test-id="6tVXwIqT"
    />
  );

  const containerRef = useRef(null);
  useOnClickOutside(containerRef, () => setOpen(false));
  return (
    <div
      ref={containerRef}
      className={cn("w-full", className)}
      test-id="zOvVg32q"
    >
      <NewDropDown test-id="KQA5Upni">
        <NewDropDown.Anchor
          size="medium"
          onClick={() => setOpen(!isOpen)}
          className={cn(anchorClassName)}
          {...anchorArgs}
          test-id="kK5DQL-Q"
        >
          <Stack test-id="V2UGIAKe">
            {anchorSlot ? (isOpen ? SearchInput : anchorSlot) : SearchInput}
          </Stack>
        </NewDropDown.Anchor>

        {isFetchingMore && (
          <div
            className="absolute right-10 top-2 text-white"
            test-id="xfIHNr2Y"
          >
            <Spinner size="sm" test-id="AwNlf0oV" />
          </div>
        )}

        <NewDropDown.Menu
          containerRef={containerRef}
          className={cn(menuClassName)}
          initialMaxHeight={350}
          minHeight={300}
          isOpen={isOpen}
          onClose={() => setOpen(false)}
          {...menuArgs}
        >
          {(close) => (
            <>
              {!!topSlot &&
              !(hideTopSlotOnSearch && search.length) &&
              typeof topSlot === "function"
                ? topSlot(close)
                : topSlot}

              <FilteredMenu list={data} filter={search} test-id="1zKzvEwh">
                {(filteredData) =>
                  children && filteredData && filteredData.length > 0 ? (
                    children(filteredData, close)
                  ) : search.length ? (
                    <div
                      className="flex w-full h-full items-center justify-center text-c-gray-400 py-4"
                      test-id="Sz7-aVVS"
                    >
                      No results were found
                    </div>
                  ) : null
                }
              </FilteredMenu>

              {!!bottomSlot && typeof bottomSlot === "function"
                ? bottomSlot(close)
                : bottomSlot}
            </>
          )}
        </NewDropDown.Menu>
      </NewDropDown>
    </div>
  );
};

export default SearchableDropDown;
